
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'wms-keep-enabled'
});
